import { getRequest, postRequest, deleteRequest } from "./services/client";

import config from "environment";

const { baseApi } = config;

export async function apiGetUser(id) {
  const fetchURL = `${baseApi}/users/${id}`;
  return await getRequest(fetchURL, "API/apiGetUser");
}

export async function apiResetConversationHistory(userId, collectionId) {
  const fetchURL = `${baseApi}/ai/reset-conversation-history`;
  return await postRequest(
    fetchURL,
    { userId, collectionId },
    "API/apiResetConversationHistory"
  );
}

export async function apiGetUserByEmail(email) {
  const fetchURL = `${baseApi}/users/by-email`;
  return await postRequest(fetchURL, { email }, "API/apiGetUserByEmail");
}

export async function apiGetUserByUsername(username) {
  const fetchURL = `${baseApi}/users/by-username/${username}`;
  return await getRequest(fetchURL, "API/apiGetUserByUsername");
}

export async function apiSetUserTheme(userId, theme) {
  const fetchURL = `${baseApi}/users/set-theme`;
  return await postRequest(fetchURL, { userId, theme }, "API/apiSetUserTheme");
}

export async function apiLoginExt(userId) {
  const fetchURL = `${baseApi}/auth/login-ext/${userId}`;
  return await getRequest(fetchURL, "API/apiLoginExt");
}

// this returns the user record of the new user or null
export async function apiCreateUserWithWorkspace(
  firstName,
  lastName,
  email,
  avatarURL,
  password,
  questionLimit = 25
) {
  const fetchURL = `${baseApi}/users/create-user-with-workspace`;

  return await postRequest(
    fetchURL,
    { firstName, lastName, email, avatarURL, password },
    "API/apiCreateUserWithWorkspace"
  );
}

export async function apiSyncAvatar(userId, avatarUrl) {
  const fetchURL = `${baseApi}/users/sync-avatar`;

  return await postRequest(
    fetchURL,
    { userId, avatarUrl },
    "API/apiSyncAvatar"
  );
}

export async function apiSaveUser(user) {
  const fetchURL = `${baseApi}/users/update`;
  return await postRequest(fetchURL, user, "API/apiSaveUser");
}

export async function apiGetMutedListForUserInWorkspace(userId, workspaceId) {
  const fetchURL = `${baseApi}/users/muted-list/${userId}/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetMutedListForUserInWorkspace");
}

export async function apiDeleteMutedListItem(mutedId) {
  const fetchURL = `${baseApi}/users/delete-muted/${mutedId}`;
  return await getRequest(fetchURL, "API/apiDeleteMutedListItem");
}

export async function apiAddUserMutedListItemToWorkspace(
  userId,
  workspaceId,
  type,
  typeId
) {
  const fetchURL = `${baseApi}/users/add-muted-list-item`;
  return await postRequest(
    fetchURL,
    { userId, workspaceId, type, typeId },
    "API/apiAddUserMutedListItemToWorkspace"
  );
}

export async function apiSetCurrentWorkspace(id, workspaceId) {
  const fetchURL = `${baseApi}/users/set-workspace`;
  return await postRequest(
    fetchURL,
    { id, workspaceId },
    "API/apiSetCurrentWorkspace"
  );
}

export async function apiSyncWorkspace(workspaceId, howManyDays = 7) {
  const fetchURL = `${baseApi}/slack/sync-workspace/${workspaceId}/${howManyDays}`;
  return await getRequest(fetchURL, "API/apiSyncWorkspace");
}

export async function apiUpsertUser(payload) {
  const fetchURL = `${baseApi}/users/upsert`;
  return await postRequest(fetchURL, payload, "API/apiUpsertUser");
}

// export async function apiCreateWorkspace(name) {
//   const fetchURL = `${baseApi}/workspaces/create`;
//   return await postRequest(fetchURL, { name }, "API/apiCreateWorkspace");
// }

export async function apiCreateWorkspaceForUser(name, userId) {
  const fetchURL = `${baseApi}/workspaces/create-for-user`;
  return await postRequest(
    fetchURL,
    { name, userId },
    "API/apiCreateWorkspaceWithUser"
  );
}

export async function apiGetMergeLink(payload) {
  const fetchURL = `${baseApi}/connected-app/merge-link`;
  return await postRequest(fetchURL, payload, "API/apiGetMergeLink");
}

export async function apiVerifyMerge(payload) {
  const fetchURL = `${baseApi}/connected-app/verify-merge`;
  return await postRequest(fetchURL, payload, "API/apiVerifyMerge");
}

export async function apiGetWorkspace(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspace");
}

export async function apiUpdateWorkspace(workspace) {
  const fetchURL = `${baseApi}/workspaces/update`;
  return await postRequest(
    fetchURL,
    { ...workspace },
    "API/apiUpdateWorkspace"
  );
}

export async function apiLeaveWorkspace(workspaceId, userId) {
  const fetchURL = `${baseApi}/workspaces/${workspaceId}/leave/${userId}`;
  return await getRequest(fetchURL, "API/apiLeaveWorkspace");
}

export async function apiAddInvite(invitedByUserId, workspaceId, email) {
  const fetchURL = `${baseApi}/invite/create`;
  return await postRequest(
    fetchURL,
    { invitedByUserId, workspaceId, email },
    "API/apiAddInvite"
  );
}

export async function apiDeleteInvite(inviteId) {
  const fetchURL = `${baseApi}/invite/${inviteId}`;
  return await deleteRequest(fetchURL, "API/apiDeleteInvite");
}

export async function apiResendInvite(inviteId) {
  const fetchURL = `${baseApi}/invite/resend/${inviteId}`;
  return await getRequest(fetchURL, "API/apiResendInvite");
}

export async function apiAddWorkspaceUser(workspaceId, id) {
  const fetchURL = `${baseApi}/workspaces/add-user`;
  return await postRequest(
    fetchURL,
    { workspaceId, id },
    "API/apiAddWorkspaceUser"
  );
}

export async function apiRemoveWorkspaceUser(workspaceId, id) {
  const fetchURL = `${baseApi}/workspaces/remove-user`;
  return await postRequest(
    fetchURL,
    { workspaceId, id },
    "API/apiRemoveWorkspaceUser"
  );
}

export async function apiDeleteWorkspace(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/delete/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiDeleteWorkspace");
}

export async function apiGetWorkspaceUsers(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/users/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceUsers");
}

export async function apiGetWorkspaceCollections(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/collections/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceCollections");
}

// payload : {
// workspaceId: string,
// userId: string
// }

export async function apiGetWorkspaceCollectionsForUser(payload) {
  const fetchURL = `${baseApi}/workspaces/collections-for-user`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiGetWorkspaceCollectionsForUser"
  );
}

export async function apiGetWorkspaceLinkRecords(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/link-records/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceLinkRecords");
}

export async function apiGetWorkspaceUserSlackIds(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/user-slack-ids/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceLinkRecords");
}

export async function apiGetWorkspaceSlackChannels(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/slack-channels/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceSlackChannels");
}

// export async function apiGetWorkspaceSlackUsers(workspaceId) {
//   const fetchURL = `${baseApi}/workspaces/slack-users/${workspaceId}`;
//   return await getRequest(fetchURL, "API/apiGetWorkspaceSlackUsers");
// }

export async function apiGetWorkspaceInvites(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/invites/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceUserSlackIds");
}

export async function apiGetWorkspaceTags(workspaceId, userId) {
  const fetchURL = `${baseApi}/workspaces/tags/${workspaceId}/user/${userId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceTags");
}

export async function apiGetWorkspaceApps(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/apps/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceApps");
}

export async function apiGetWorkspaceContributors(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/contributors/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceContributors");
}

export async function apiGetWorkspaceMembers(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/members/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspacMembers");
}

export async function apiGetWorkspaceTargets(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/targets/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceTargets");
}

export async function apiUpdateWorkspaceSelfService(workspaceId, selfService) {
  const fetchURL = `${baseApi}/workspaces/self-service/${workspaceId}/${selfService}`;
  return await getRequest(
    fetchURL,
    { workspaceId, selfService },
    "API/apiupdateWorkspaceSelfService"
  );
}

export async function apiUpdateWorkspaceSlackSelfService(
  workspaceId,
  selfService
) {
  const fetchURL = `${baseApi}/workspaces/slack-self-service/${workspaceId}/${selfService}`;
  return await getRequest(
    fetchURL,
    { workspaceId, selfService },
    "API/apiupdateWorkspaceSlackSelfService"
  );
}

export async function apiGetTeamsAvailableConnectedApps(workspaceId) {
  const fetchURL = `${baseApi}/workspaces/available-connected-apps/${workspaceId}/MICROSOFT`;
  return await getRequest(
    fetchURL,
    { workspaceId },
    "API/apiGetTeamsAvailableConnectedApps"
  );
}

export async function apiUpdateWorkspaceConnectedApp(
  workspaceId,
  connectedAppId
) {
  const fetchURL = `${baseApi}/workspaces/update-workspace-connected-app`;
  return await postRequest(
    fetchURL,
    { workspaceId, connectedAppId },
    "API/apiUpdateWorkspaceConnectedApp"
  );
}

export async function apiUpdateWorkspaceSlackSourceUserId(
  workspaceId,
  slackSourceUserId
) {
  const fetchURL = `${baseApi}/workspaces/update-slack-source-user-id`;
  return await postRequest(
    fetchURL,
    { workspaceId, slackSourceUserId },
    "API/apiUpdateWorkspaceSlackSourceUserId"
  );
}

export async function apiRemoveHrisIntegration(workspaceId) {
  const fetchURL = `${baseApi}/employees/disconnect/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiRemoveHrisIntegration");
}
